import React from 'react';
import { Wrapper, Title, Description, Agent } from './styled';
import { useSelector } from 'react-redux';
import { selectAgentExecutionSelected } from 'store/Agents/selectors';
import { get } from 'lodash';

const ToolInfo = ({ type, isCloud }) => {
  const agentExecutionSelected = useSelector(selectAgentExecutionSelected);
  const name = get(agentExecutionSelected, '[0].agent_name', '');
  const cloudName = get(agentExecutionSelected, '[0].cloud_agent_name', '');
  const category = get(agentExecutionSelected, '[0].category[0]', '');

  return (
    <Wrapper>
        <Title children={ isCloud ? cloudName : type } />
        <Description children={ category } />
        <Agent children={ name } />
    </Wrapper>
  );
};

export default ToolInfo;
